var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-no-wrap"},[_vm._t("startDate",[_vm._v("\n      "+_vm._s(_vm.convertToHumanReadableDate(_vm.item.clockIn.date))+"\n  ")],{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }